module.exports = __webpack_public_path__ + "img/Newbie_Shield_02_Warrior.70029d60.png";